module.exports = __webpack_public_path__ + "img/person.e4a70dd7.svg";